import { actions } from "@/constants/state";
import store from "@/store";

export default async (to, from, next) => {
  try {
    await store.dispatch(actions.TEMPLATES_SEARCH_ACTION);
  } catch (error) {
    console.error(actions.TEMPLATES_SEARCH_ACTION, error);
  }

  next();
};
